// Mock data for HMI Dashboard V2
// All data is static placeholder — will be replaced with API calls later

export const STAT_CARDS = [
  { id: 'activeBids', label: 'ACTIVE BIDS', value: '12', sub: '3 due this week', meter: { width: 25, fill: 'warn' } },
  { id: 'openProjects', label: 'OPEN PROJECTS', value: '34', sub: '8 in progress \u00b7 26 scheduled' },
  { id: 'pipelineValue', label: 'PIPELINE VALUE', value: '$2.4M', sub: 'PipeDrive \u00b7 47 leads', meter: { width: 62, fill: 'brand' } },
  { id: 'unclaimedWork', label: 'UNCLAIMED WORK', value: '8', sub: '3 urgent \u00b7 needs assignment', numClass: 'warn' },
  { id: 'issues', label: 'ISSUES', value: '5', sub: '2 escalated \u00b7 1 new today', numClass: 'warn', meter: { width: 40, fill: 'risk' } },
]

export const CORE_TOOLS = [
  {
    id: 'bids', title: 'Bids',
    desc: 'Bid assembly, line items, cost estimation, and output generation.',
    stripeColor: 'var(--brand)', iconBg: 'var(--brand-tint)', iconColor: 'var(--brand-deep)',
    icon: 'document',
    pill: { label: '3 due', tone: 'warn' },
    stats: [{ value: '12', label: 'active' }, { value: '3', label: 'draft' }, { value: '$2.1M', label: 'total' }],
    href: '/bid-estimation',
  },
  {
    id: 'projects', title: 'Projects',
    desc: 'Active project management synced from Aspire. Track status, crews, and schedules.',
    stripeColor: 'oklch(0.56 0.08 230)', iconBg: 'var(--info-tint)', iconColor: 'var(--info)',
    icon: 'screen',
    pill: { label: 'On track', tone: 'ok' },
    stats: [{ value: '34', label: 'open' }, { value: '8', label: 'in progress' }],
    href: '/projects',
  },
  {
    id: 'leads', title: 'Leads',
    desc: 'Lead pipeline from PipeDrive. Track proposals, follow-ups, and conversions.',
    stripeColor: 'var(--accent)', iconBg: 'var(--accent-tint)', iconColor: 'var(--accent-deep)',
    icon: 'people',
    pill: { label: 'PipeDrive', tone: 'info' },
    stats: [{ value: '47', label: 'leads' }, { value: '12', label: 'qualified' }, { value: '28%', label: 'conv.' }],
    href: '/leads',
  },
  {
    id: 'estimatingConfigs', title: 'Estimating Configs',
    desc: 'Rate tables, service library, vendor pricing, and markup rules.',
    stripeColor: 'oklch(0.45 0.12 305)', iconBg: 'oklch(0.94 0.04 305)', iconColor: 'oklch(0.45 0.12 305)',
    icon: 'gear',
    stats: [{ value: '6', label: 'rate tables' }, { value: '248', label: 'services' }],
    href: '/bid-estimation/rates',
  },
  {
    id: 'subcontractors', title: 'Subcontractors',
    desc: 'Subcontractor portal, scheduling, messaging, and compliance tracking.',
    stripeColor: 'oklch(0.45 0.08 270)', iconBg: 'oklch(0.94 0.03 270)', iconColor: 'oklch(0.45 0.08 270)',
    icon: 'people',
    stats: [{ value: '12', label: 'active' }, { value: '4', label: 'pending' }],
    href: '/subcontractors',
  },
  {
    id: 'communications', title: 'Communications',
    desc: 'Voicemail and SMS from VoIP. Respond, assign, or archive messages.',
    stripeColor: 'var(--accent)', iconBg: 'var(--accent-tint)', iconColor: 'var(--accent-deep)',
    icon: 'phone',
    pill: null,
    stats: [{ value: '0', label: 'VM' }, { value: '0', label: 'SMS' }],
    href: null,
  },
]

export const OPS_DASHBOARDS = [
  {
    id: 'herbicide', title: 'Herbicide',
    desc: 'Application tracking, chemical inventory, compliance logs, and crew schedules.',
    stripeColor: 'oklch(0.45 0.12 305)', iconBg: 'oklch(0.94 0.04 305)', iconColor: 'oklch(0.45 0.12 305)',
    icon: 'shield',
    stats: [{ value: '6', label: 'scheduled' }, { value: '94%', label: 'compliant' }],
    href: '/herbicide-schedule-v4',
  },
  {
    id: 'irrigation', title: 'Irrigation',
    desc: 'System health, controller status, repair tickets, and water usage metrics.',
    stripeColor: 'oklch(0.42 0.10 230)', iconBg: 'oklch(0.94 0.04 230)', iconColor: 'oklch(0.42 0.10 230)',
    icon: 'droplet',
    pill: { label: '2 alerts', tone: 'warn' },
    stats: [{ value: '142', label: 'zones' }, { value: '2', label: 'offline' }],
    href: '/hmiirrigationdashboard',
  },
  {
    id: 'routing', title: 'Routing',
    desc: 'Optimize maintenance routes, crew assignments, and drive time reduction.',
    stripeColor: 'oklch(0.42 0.08 195)', iconBg: 'oklch(0.94 0.04 195)', iconColor: 'oklch(0.42 0.08 195)',
    icon: 'mapPin',
    stats: [{ value: '14', label: 'routes' }, { value: '-12%', label: 'drive time' }],
    href: '/routing',
  },
  {
    id: 'shop', title: 'Shop',
    desc: 'Repair requests, fleet overview, fitment tracking, and shop inventory.',
    stripeColor: 'oklch(0.48 0.06 45)', iconBg: 'oklch(0.94 0.02 45)', iconColor: 'oklch(0.48 0.06 45)',
    icon: 'wrench',
    stats: [{ value: '5', label: 'open repairs' }, { value: '3', label: 'in progress' }],
    href: '/shop',
  },
  {
    id: 'disposal', title: 'Disposal / Waste',
    desc: 'Waste manifests, dump tickets, disposal costs, and haul tracking.',
    stripeColor: 'oklch(0.50 0.14 25)', iconBg: 'oklch(0.94 0.04 25)', iconColor: 'oklch(0.50 0.14 25)',
    icon: 'trash',
    stats: [{ value: '18', label: 'tickets' }, { value: '$4.2K', label: 'MTD' }],
    href: '/bid-estimation/rates',
  },
  {
    id: 'aggregate', title: 'Aggregate',
    desc: 'Material orders, tonnage tracking, vendor pricing, and delivery schedules.',
    stripeColor: 'oklch(0.42 0.04 60)', iconBg: 'oklch(0.93 0.012 60)', iconColor: 'oklch(0.42 0.04 60)',
    icon: 'layers',
    stats: [{ value: '320', label: 'tons MTD' }, { value: '$18.6K', label: '' }],
    href: '/bid-estimation/rates',
  },
]

export const ATTENTION_ITEMS = [
  { type: 'alert', label: 'Bid #2148 due tomorrow', desc: 'Dessie Lorenz Park \u00b7 0% margin', ts: '11h', icon: 'warning' },
  { type: 'alert', label: 'Irrigation Zone 14 offline', desc: 'Scottsdale Greens \u00b7 controller unresponsive', ts: '2h', icon: 'warning' },
  { type: 'warn', label: '8 unclaimed work orders', desc: '3 marked urgent \u00b7 Aspire sync', ts: '4h', icon: 'triangleWarning' },
  { type: 'warn', label: 'Herbicide license expiry', desc: 'Crew Lead M. Reyes \u00b7 expires May 22', ts: '1d', icon: 'triangleWarning' },
  { type: 'accent', label: 'Voicemail from Sun Valley HOA', desc: 'Callback requested \u00b7 re: proposal', ts: '14m', icon: 'phoneIncoming' },
  { type: 'info', label: 'New customer feedback', desc: 'Mesa Ridge \u00b7 5-star review', ts: '3h', icon: 'mail' },
]

export const ACTIVITY_ITEMS = [
  { type: 'brand', label: 'Bid #2156 submitted', desc: 'Anthem Park Phase 2 \u00b7 $186K', ts: '1h', icon: 'check' },
  { type: 'ok', label: 'Lead qualified', desc: 'Surprise Commercial Plaza \u00b7 PipeDrive', ts: '3h', icon: 'userPlus' },
  { type: 'info', label: 'Routes optimized', desc: '14 routes \u00b7 saved 42 miles/day', ts: '5h', icon: 'calendar' },
  { type: 'brand', label: 'Irrigation repair completed', desc: 'Zone 8 \u00b7 Peoria Community Park', ts: '6h', icon: 'droplet' },
  { type: 'ok', label: 'Waste invoice processed', desc: 'Dump ticket #1847 \u00b7 $620', ts: '8h', icon: 'dollar' },
]

export const BID_DEADLINES = [
  { type: 'alert', label: 'Dessie Lorenz Park', id: 'P-2148', value: '$234K', statusPill: { label: 'Draft', tone: 'warn' }, ts: 'Tomorrow', tsUrgent: true, icon: 'clock' },
  { type: 'warn', label: 'Surprise City Hall Median', id: 'P-2161', value: '$89K', statusPill: { label: 'In progress', tone: 'info' }, ts: 'May 16', icon: 'clock' },
  { type: 'info', label: 'Anthem Community Park Ph.3', id: 'P-2170', value: '$412K', statusPill: { label: 'Draft', tone: 'warn' }, ts: 'May 23', icon: 'clock' },
]

export const QUICK_LINKS = [
  { label: 'Issues', count: '5', dotColor: 'var(--risk)', href: '#' },
  { label: 'Equipment', dotColor: 'oklch(0.45 0.06 150)', href: '/equipment' },
  { label: 'Fleet Tracking', dotColor: 'var(--brand)', href: '/admin/geotab-dashboard' },
  { label: 'Dead Plants', dotColor: 'oklch(0.50 0.14 25)', href: '/admin-dead-plants-dashboard' },
  { label: 'Vendors', dotColor: 'oklch(0.50 0.10 55)', href: '/vendors' },
  { label: 'Vendor Catalogs', dotColor: 'oklch(0.50 0.10 55)', href: '/vendor-catalogs' },
  { label: 'Knowledge Base', dotColor: 'oklch(0.42 0.08 195)', href: '/knowledge-base' },
  { label: 'Customer Feedback', dotColor: 'var(--ok)', href: '/complaints' },
  { label: 'Reports', dotColor: 'var(--info)', href: '/reports' },
]

export const CONNECTED_SYSTEMS = [
  {
    id: 'aspire', name: 'Aspire CRM',
    desc: 'Primary CRM \u00b7 Projects, work orders, crews, scheduling, and invoicing',
    logoBg: 'oklch(0.94 0.04 230)', logoColor: 'oklch(0.42 0.10 230)', logoLetter: 'A',
    stats: [{ value: '34', label: 'projects' }, { value: '86', label: 'work orders' }, { value: '2m ago', label: 'Synced' }],
    buttonLabel: 'Open Aspire',
    href: '#', // TODO: window.open to Aspire
  },
  {
    id: 'pipedrive', name: 'PipeDrive',
    desc: 'Lead management \u00b7 Pipeline, proposals, contacts, and deal tracking',
    logoBg: 'oklch(0.94 0.04 155)', logoColor: 'var(--brand-deep)', logoLetter: 'P',
    stats: [{ value: '47', label: 'leads' }, { value: '$2.4M', label: 'pipeline' }, { value: '5m ago', label: 'Synced' }],
    buttonLabel: 'Open PipeDrive',
    href: '#', // TODO: window.open to PipeDrive
  },
]

export const UNCLAIMED_ITEMS = [
  { type: 'warn', label: 'Dead turf \u2014 Scottsdale Greens east median', urgentPill: true, desc: 'Phone call \u00b7 Sun Valley HOA \u00b7 Irrigation', ts: '3d', icon: 'warning' },
  { type: 'info', label: 'Broken header \u2014 Anthem Park entrance', desc: 'Field observation \u00b7 T. Nguyen \u00b7 Irrigation', ts: '3d', icon: 'grid' },
  { type: 'info', label: 'Weed treatment request \u2014 Mesa Ridge pool area', desc: 'SMS (VoIP) \u00b7 Mesa Ridge Community \u00b7 Herbicide', ts: '4d', icon: 'grid' },
]

export const CONTACTS = {
  customers: ['Sun Valley HOA', 'Mesa Ridge Community', 'Anthem Parks Dept', 'City of Surprise', 'Peoria Public Works'],
  internal: ['M. Reyes (Crew Lead)', 'T. Nguyen (PM)', 'J. Chen (Estimator)'],
}

export const SOURCES = [
  'Phone call', 'Voicemail (VoIP)', 'SMS (VoIP)', 'Email',
  'Field observation', 'Aspire work order', 'Customer portal', 'Walk-in',
]

export const SERVICE_TYPES = [
  { label: 'Irrigation', dotColor: 'oklch(0.42 0.10 230)' },
  { label: 'Herbicide', dotColor: 'oklch(0.45 0.12 305)' },
  { label: 'Hardscape', dotColor: 'oklch(0.42 0.04 60)' },
  { label: 'Planting', dotColor: 'var(--brand-deep)' },
  { label: 'Disposal', dotColor: 'oklch(0.50 0.14 25)' },
  { label: 'General', dotColor: 'var(--ink-3)' },
]
